import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createUnknownComponentVNode as _$cc } from 'intact-vue';
import { Button } from '../button';
import { Icon } from '../icon';
import { Input } from '../input';
import { getRestProps } from '../utils';
import { makeStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    className = _this$get.className,
    disabled = _this$get.disabled,
    size = _this$get.size,
    vertical = _this$get.vertical,
    value = _this$get.value,
    width = _this$get.width;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-spinner"] = true, _classNameObj[k + "-disabled"] = disabled, _classNameObj[k + "-" + size] = size !== 'default', _classNameObj[className] = className, _classNameObj[k + "-vertical"] = vertical, _classNameObj[makeStyles(k)] = true, _classNameObj);
  var _this$change = this.change,
    decrease = _this$change.decrease,
    increase = _this$change.increase,
    onChangeValue = _this$change.onChangeValue,
    onFocusin = _this$change.onFocusin;
  var _this$value = this.value,
    showValue = _this$value.showValue,
    onInput = _this$value.onInput;
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), [_$cc(Button, {
    'icon': true,
    'ev-click': decrease,
    'disabled': this.isDisabledDecrease(),
    'className': _$cn(k + "-spinner-btn " + k + "-left"),
    'size': size,
    'type': 'none',
    'tabindex': '-1',
    'children': !vertical ? _$cc(Icon, {
      'className': _$cn(k + "-spinner-icon " + k + "-icon-minus")
    }) : _$cc(Icon, {
      'className': _$cn(k + "-spinner-icon " + k + "-icon-down")
    })
  }), _$cc(Input, {
    'className': _$cn(k + "-spinner-input"),
    'disabled': disabled,
    'ev-change': onChangeValue,
    'ev-focusin': onFocusin,
    'value': showValue.value,
    'ev-input': onInput,
    'size': size,
    'width': width
  }), _$cc(Button, {
    'icon': true,
    'ev-click': increase,
    'disabled': this.isDisabledIncrease(),
    'className': _$cn(k + "-spinner-btn " + k + "-right"),
    'size': size,
    'type': 'none',
    'tabindex': '-1',
    'children': !vertical ? _$cc(Icon, {
      'className': _$cn(k + "-spinner-icon " + k + "-icon-add")
    }) : _$cc(Icon, {
      'className': _$cn(k + "-spinner-icon " + k + "-icon-up")
    })
  })]);
}
;